//Purpose of this file: https://github.com/go-highway/highway-onboarding/pull/1042/
import axios from '@/axiosInterceptor';

const state = () => ({
  showIDVFlow: false,
  isPreferredNameModalActive: false,
  customFields: null,
  isCompanyEmailModalActive: false,
  confirmationPending: false,
  redirectAfterIDV: {
    name: null,
    path: null,
  },
});

// getters
const getters = {
  getRedirectAfterIDV: (state) => {
    if (
      state.redirectAfterIDV.name !== null ||
      state.redirectAfterIDV.path !== null
    ) {
      return state.redirectAfterIDV;
    }

    return (
      JSON.parse(localStorage.getItem('redirectAfterIDV')) ||
      state.redirectAfterIDV
    );
  },
};

// actions
const actions = {
  async getCustomFields({ commit }, carrierId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/idv_payload/${carrierId}`
      );
      commit('setCustomFields', res.data);
    } catch (e) {
      if (
        axios.isAxiosError(e) &&
        [401, 403, 422].includes(e?.response?.status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setCustomFields(state, data) {
    state.customFields = data;
  },
  setPreferredNameModal(state, value) {
    state.isPreferredNameModalActive = value;
  },
  setIsCompanyEmailModal(state, value) {
    state.isCompanyEmailModalActive = value;
  },
  setIsConfirmationPending(state, value) {
    state.confirmationPending = value;
  },
  setShowIDVFlow(state, value) {
    state.showIDVFlow = value;
  },
  setRedirectAfterIDV(state, { name = null, path = null }) {
    localStorage.setItem('redirectAfterIDV', JSON.stringify({ name, path }));
    state.redirectAfterIDV = { name, path };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
